import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Table, Params, Merge, Menu, Actions } from 'nallian-table-builder-ui';
import { GetOrganisationId, GetRights } from 'nallian-shared-ui/lib/selectors';
import { hasRight } from 'nallian-shared-ui/lib/lib/routesHelper';
import {
  INFINITE_SCROLL,
  FILTER_SETTINGS,
  ACCESS_RIGHTS_RESOURCE,
  ON_PREMISE_ACCESS_RIGHTS_RESOURCE,
  ACCESS_RIGHTS_ACTIONS,
  DEFAULT_SORT,
} from '../constants';
import apiRoutes from '../../../app/api/routes';
import CreatedOnFilter from '../../vehicles/components/table/CreatedOnFilter';

const ConditionalMenu = ({ organisationId, item, children }) => {
  if (organisationId !== item.onPremiseOrganisationId) {
    return null;
  }

  return children;
};

const AccessRightsOverviewTable = ({ isPrivate, baseUrl }) => {
  const organisationId = useSelector(GetOrganisationId);
  const rights = useSelector(GetRights);
  const canUpdate = useMemo(() => hasRight(rights, 'access-rights/update'), [rights]);

  return (
    <Table
      infiniteScroll={INFINITE_SCROLL}
      filtered={FILTER_SETTINGS}
      sorted={DEFAULT_SORT}
      resource={isPrivate ? ON_PREMISE_ACCESS_RIGHTS_RESOURCE : ACCESS_RIGHTS_RESOURCE}
      url={
        isPrivate ? apiRoutes.onPremiseAccessRights({ organisationId }) : apiRoutes.accessRights()
      }
      rootTableProperty="values"
      pageSize={50}
      noUserSettings
    >
      <Params.String
        link={canUpdate ? `${baseUrl}/${ACCESS_RIGHTS_ACTIONS.DETAILS}/:vehicleId` : undefined}
        name="licensePlate"
        width="5.5rem"
        grow
      />
      <Params.String name="state" width="5.5rem" grow noFilter />
      <Params.DateTime name="createdOn" filter={CreatedOnFilter} width="5.5rem" grow noFilter />
      {!isPrivate && (
        <Params.String
          name="onPremiseOrganisationName"
          label="approver"
          width="5.5rem"
          grow
          noSort
          noFilter
        />
      )}
      <Params.String
        name="offPremiseOrganisationName"
        label="owner"
        width="5.5rem"
        grow
        noSort
        noFilter
      />
      <Merge
        align="center"
        label="‎"
        width="3.5rem"
        name="menu"
        noSort
        organisationId={organisationId}
        as={ConditionalMenu}
        hasRight="access-rights/delete"
      >
        <Menu width="3.5rem">
          <Actions.Delete url={apiRoutes.accessRight(':id')} />
        </Menu>
      </Merge>
    </Table>
  );
};

AccessRightsOverviewTable.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  isPrivate: PropTypes.bool,
};
AccessRightsOverviewTable.defaultProps = { isPrivate: false };

export default AccessRightsOverviewTable;
